import { useCatalog } from '../../contexts/CatalogContext';
import { useSite } from '../../contexts/SiteContext';
import { tierIn } from '../../data/gifts';
import { euro } from '../../core/format/currency';

/**
 * Snel vergelijken — vergelijkende inhoud hoort in een tabel. `hideHeading`: de kop staat al
 * erboven (bijv. als knop van een uitklapper); dan alleen de tabel, met de kop als naam.
 */
export function RoutineCompare({
  heading,
  hideHeading = false
}: {
  heading: string;
  hideHeading?: boolean;
}) {
  const {
    routines,
    routineTotals
  } = useCatalog();
  const {
    giftTiers
  } = useSite();
  // Vergelijken kan pas vanaf twee protocollen; anders een tabel met één (of nul) rijen.
  if (routines.length < 2) return null;
  return <div className={`${hideHeading ? 'mt-4' : 'mt-16'} min-w-0`} data-id="element-8538" data-mp="3n93eqtfnnx5q">
      {!hideHeading && <h3 id="routine-compare" className="type-title text-ink" data-id="element-8539" data-mp="3s8pp8v43mzau">
          {heading}
        </h3>}
      {/* Scrollbaar op mobiel; met het toetsenbord bereikbaar zodat je ook zonder muis kunt schuiven. */}
      <div className={`-mx-6 overflow-x-auto px-6 lg:mx-0 lg:px-0 ${hideHeading ? '' : 'mt-6'}`} tabIndex={0} role="region" {...hideHeading ? {
      'aria-label': heading
    } : {
      'aria-labelledby': 'routine-compare'
    }} data-id="element-8540" data-mp="1run80mzz5ca8">
        <table className="w-full min-w-[640px] border-collapse text-left" data-id="element-8541" data-mp="1cwcsqo8k3rjd">
          <caption className="sr-only" data-id="element-8542" data-mp="1cyfrpxrosv08">{heading}: per protocol voor wie, hoe lang, welk cadeau en de prijs</caption>
          <thead data-id="element-8543" data-mp="2alxyj31sfn1l">
            <tr className="border-b border-ink/25 text-[13px] text-muted" data-id="element-8544" data-mp="25labstkldsd6">
              <th scope="col" className="py-3 pr-6 font-normal" data-id="element-8545" data-mp="25ncz35ud17e7">
                Protocol
              </th>
              <th scope="col" className="py-3 pr-6 font-normal" data-id="element-8546" data-mp="1vv75jrogmhww">
                Voor wie
              </th>
              <th scope="col" className="py-3 pr-6 font-normal" data-id="element-8547" data-mp="2tabcfun6nz7w">
                Gaat mee
              </th>
              <th scope="col" className="py-3 pr-6 font-normal" data-id="element-8548" data-mp="2ojcr2gnc8axs">
                Cadeau
              </th>
              <th scope="col" className="py-3 text-right font-normal" data-id="element-8549" data-mp="mm2ke6yxjxar">
                Prijs
              </th>
            </tr>
          </thead>
          <tbody data-id="element-8550" data-mp="rkmbsmwam1ai">
            {routines.map(r => {
            const t = routineTotals(r);
            const gift = tierIn(giftTiers, t.price);
            return <tr key={r.id} className="border-b border-line align-top text-[15px]" data-id="element-8551" data-mp="hub3ko5kt5xt">
                  <th scope="row" className="py-4 pr-6 type-name font-normal text-ink" data-id="element-8552" data-mp="3urvfvcrluli">
                    {r.name}
                  </th>
                  <td className="py-4 pr-6 text-muted" data-id="element-8553" data-mp="7vbuj4gwf8aa">{r.forWho}</td>
                  <td className="whitespace-nowrap py-4 pr-6 text-muted" data-id="element-8554" data-mp="3q4cmnlwkcvzv">{t.months}</td>
                  <td className="py-4 pr-6 text-muted" data-id="element-8555" data-mp="3v373iiaz0ahc">
                    {gift ? gift.title : <>
                        <span aria-hidden="true" data-id="element-8556" data-mp="1tbav3hk3ngqs">—</span>
                        <span className="sr-only" data-id="element-8557" data-mp="1t9zpdc73fyx1">Geen cadeau</span>
                      </>}
                  </td>
                  <td className="whitespace-nowrap py-4 text-right type-name tabular-nums text-ink" data-id="element-8558" data-mp="38tz1t2xlbukq">{euro(t.price)}</td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </div>;
}